export default "__VITE_ASSET__Bc8lDifV__"